import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { AuthDebug } from '../components/auth';

/**
 * Temporary test page for authentication integration testing
 * This page should be removed after testing is complete
 */
const AuthTestPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Authentication Test Page
      </Typography>
      <Typography variant="body1" paragraph color="text.secondary">
        This is a temporary page for testing authentication integration.
      </Typography>
      
      <AuthDebug />
      
      <Box sx={{ mt: 4, p: 2, bgcolor: 'warning.light', borderRadius: 1 }}>
        <Typography variant="caption">
          Note: This page is for testing only and should be removed before production deployment.
        </Typography>
      </Box>
    </Container>
  );
};

export default AuthTestPage;